module.exports = "/fonts/PT Root UI_Bold.ttf?322151afe6ce40fd9fc91607696cdc4a";